import React, { Component } from "react"
import "./NextGame.scss"
import ScrollableAnchor from "react-scrollable-anchor";
import Ticker from "./Ticker/Ticker";
import GameInfo from "./GameInfo/GameInfo";
import { _getGames } from "../Services/Fetch/gameinfo";

class NextGame extends Component {
    constructor() {
        super();
        this.fetchGameDATA = this.fetchGameDATA.bind(this);
        this.state = {
            games: [],
            ticker: []
        }
    }
    async componentDidMount() {
        const data = await _getGames();
        this.setState({
            ticker: data,
            games: data
        })
        window.setInterval(this.fetchGameDATA, 60000);
    }
    async fetchGameDATA() {
        const data = await _getGames();
        this.setState({
            games: data
        })
    }
    render() {
        return (
            <ScrollableAnchor id="nextgame">
                <section className="section section-nextgame">
                    <div className="padding">
                        <div className="container">
                            <GameInfo data={this.state.games} />
                            <div className="separator"></div>
                            <Ticker data={this.state.ticker} />
                        </div>
                    </div>
                </section>
            </ScrollableAnchor>
        )
    }
}

export default NextGame;


// WEBPACK FOOTER //
// ./src/Components/NextGame/NextGame.jsx